(() => {
  const guardSelector = '[data-timesact-preorder-guard]';
  const initializationTimeout = 8000;

  function isTimesactPreOrderReady(form) {
    const submitButton = form.querySelector('.product-form__submit');
    const hasSellingPlan = form.querySelector('[data-timesact-selling-plan]');
    const hasTrackingProperty = form.querySelector('[data-timesact-tracking]');
    const hasPreOrderMessage = form.querySelector('.timesact-preOrder-message');
    const buttonText = submitButton?.textContent || '';

    return (
      (hasSellingPlan || hasTrackingProperty || hasPreOrderMessage) &&
      /pre[\s-]?order/i.test(buttonText)
    );
  }

  function initializeGuard(root) {
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const failureMessage = root.querySelector('[data-timesact-preorder-failure]');

    if (!form || !failureMessage) return;

    let settled = false;
    let timeoutId;

    const observer = new MutationObserver(() => {
      if (!settled && isTimesactPreOrderReady(form)) {
        settled = true;
        window.clearTimeout(timeoutId);
        observer.disconnect();
        root.classList.add('timesact-preorder-ready');
      }
    });

    observer.observe(form, {
      attributes: true,
      attributeFilter: ['class', 'style', 'value'],
      childList: true,
      subtree: true,
    });

    if (isTimesactPreOrderReady(form)) {
      settled = true;
      observer.disconnect();
      root.classList.add('timesact-preorder-ready');
      return;
    }

    timeoutId = window.setTimeout(() => {
      if (settled) return;

      settled = true;
      observer.disconnect();
      root.classList.add('timesact-preorder-error');
      failureMessage.hidden = false;
    }, initializationTimeout);
  }

  document.querySelectorAll(guardSelector).forEach(initializeGuard);
})();